module.exports = __webpack_public_path__ + "static/media/regionFCS_2022.04421e5f.png";